import { memo, useCallback } from 'react';
import type { StationFormData } from '../stationForm';

interface ScheduleSectionProps {
  formData: StationFormData;
  onFieldChange: <K extends keyof StationFormData>(
    field: K,
    value: StationFormData[K]
  ) => void;
}

export const ScheduleSection = memo(function ScheduleSection({
  formData,
  onFieldChange,
}: ScheduleSectionProps) {
  const handleAroundTheClockChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFieldChange('aroundTheClock', e.target.checked);
    },
    [onFieldChange]
  );

  const handleStartWorkingTimeChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFieldChange('startWorkingTime', e.target.value);
    },
    [onFieldChange]
  );

  const handleEndWorkingTimeChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFieldChange('endWorkingTime', e.target.value);
    },
    [onFieldChange]
  );

  return (
    <section className="form-section">
      <h2 className="section-title">
        <span className="material-symbols-outlined section-icon">access_time</span>
        Working Schedule
      </h2>

      <div className="schedule-content">
        {/* 24/7 Toggle */}
        <label className="toggle-24h">
          <input
            type="checkbox"
            className="toggle-checkbox"
            checked={formData.aroundTheClock}
            onChange={handleAroundTheClockChange}
          />
          <span className="toggle-label">Open 24/7</span>
        </label>

        {/* Time Range Inputs */}
        <div className={`time-range-grid ${formData.aroundTheClock ? 'disabled' : ''}`}>
          <div className="form-field">
            <label className="field-label">Opening Time</label>
            <input
              type="time"
              className="field-input time-input"
              value={formData.startWorkingTime}
              onChange={handleStartWorkingTimeChange}
              disabled={formData.aroundTheClock}
            />
          </div>
          <div className="form-field">
            <label className="field-label">Closing Time</label>
            <input
              type="time"
              className="field-input time-input"
              value={formData.endWorkingTime}
              onChange={handleEndWorkingTimeChange}
              disabled={formData.aroundTheClock}
            />
          </div>
        </div>
      </div>
    </section>
  );
});

export default ScheduleSection;
